import { PERMISSIONS } from '@/lib/constants/permissions'
import { useCompanyContext } from '@/lib/context/companyContext'
import { useFlags } from 'launchdarkly-react-client-sdk'
import { NavIds, navItems as baseNavItems } from './nav'

export const useNavItems = () => {
	const { permissions } = useCompanyContext()
	const { tempBoss1863EnableCannyWidget } = useFlags()

	// Helper function to check if user has a specific permission
	const hasPermission = (permission: string) =>
		permissions?.includes(permission)

	// Don't render navigation items while permissions are still loading
	// This prevents flickering during the initial permission fetch
	if ((permissions && permissions.length === 0) || !permissions) {
		return []
	}

	const navItems = baseNavItems
		.map(item => {
			// Apply feature flag logic for Agent Management
			if (item.navId === NavIds.AgentManagement) {
				return {
					...item,
					show: hasPermission(PERMISSIONS.OFFICE_MANAGER_USER),
				}
			}

			// Apply permission-based filtering for other navigation items
			if (
				item.navId === NavIds.BusinessIntelligence ||
				item.navId === NavIds.BI
			) {
				return {
					...item,
					show: hasPermission(PERMISSIONS.BROKER_ADMIN_USER),
				}
			}

			if (item.navId === NavIds.Recruiting) {
				return {
					...item,
					show: hasPermission(PERMISSIONS.RECRUITING_USER),
				}
			}

			// Show Feedback only when feature flag is enabled
			if (item.navId === NavIds.Feedback) {
				return {
					...item,
					show: tempBoss1863EnableCannyWidget === true,
				}
			}

			// Always show Signout - no permission required
			if (item.navId === NavIds.Signout) {
				return {
					...item,
					show: true,
				}
			} // Default to showing the item if no specific permission logic applies
			return {
				...item,
				show: true,
			}
		})
		.filter(item => item.show)

	return navItems
}
